import { noop } from 'lodash'
import React from 'react'

type TToggleSwitch = {
  value?: boolean
  onChange?: (val: boolean) => void
  labelFirst?: boolean
  id?: string
  label?: string
  inline?: boolean
  disabled?: boolean
  customWrapperClasses?: string
}
const ToggleSwitch = (props: TToggleSwitch): React.ReactElement => {
  const {
    value,
    onChange = noop,
    labelFirst = false,
    id,
    label,
    inline = false,
    disabled = false,
    customWrapperClasses,
  } = props

  const changeHandler = (): void => {
    onChange(!value)
  }

  return (
    <div
      className={`custom-control custom-switch ${customWrapperClasses} ${
        labelFirst ? 'custom-control-right' : null
      }`}
      style={{ display: inline ? 'inline' : 'block' }}
    >
      <input
        type="checkbox"
        checked={value}
        className="custom-control-input"
        disabled={disabled}
        id={id}
        onChange={() => changeHandler()}
      />

      <label
        className="custom-control-label"
        htmlFor={id}
        style={{ cursor: 'pointer', paddingTop: '1px' }}
      >
        {label}
      </label>
    </div>
  )
}

export default ToggleSwitch
